import {
    Component,
    ViewChild,
    Input,
    OnChanges,
    SimpleChanges,
    ElementRef,
    Renderer2, OnInit
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IntervalObservable } from 'rxjs/observable/IntervalObservable';
import 'rxjs/add/operator/takeWhile';

import { BufferChangeReason } from 'app/buffer-graph/models/buffer-change-reasons/buffer-change-reason';
import { TabComponentBase } from 'app/buffer-graph/models/tab-component-base';
import { SlickGridComponent } from 'app/slick-grid/slick-grid.component';
import { BufferGraphService } from 'app/buffer-graph/services/buffer-graph.service';
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import {ITabInfo} from "../../models/tab-info-interface";
import * as moment from "moment";
import {ExcelWorkService} from "../../../services/excel-work.service";
import {ModuleTableName} from "../../../shared/models/module-table-name";

@Component({
    selector: 'buffer-change-reasons',
    templateUrl: './buffer-change-reasons.component.html',
    styleUrls: ['../../../slick-grid/stocks-grid-style.css', '../../styles/tabs-styles.css', './buffer-change-reasons.component.css']
})
export class BufferChangeReasonsComponent extends TabComponentBase<any, any> implements OnChanges, OnInit {
    constructor(
        graphService: BufferGraphService,
        exchangeService: BufferGraphDataExchangeService,
        excelService: ExcelWorkService,
        translateService: TranslateService,
        renderer: Renderer2,
        elementRef: ElementRef
    ) {
        super(graphService, exchangeService, excelService, translateService, renderer, elementRef);

        this.dataView = new Slick.Data.DataView<any>();
        this.options = { syncColumnCellResize: true, multiColumnSort: false, editable: false, enableColumnReorder: false };
        this.headersDataView = new Slick.Data.DataView<any>();
        this.headersOptions = {
            syncColumnCellResize: true,
            multiColumnSort: false,
            editable: false,
            enableColumnReorder: false,
            enableCellNavigation: false,
            enableAsyncPostRender: true,
            boundary: 'body'
        };

        this.translates = {};
        this.gridPropsName = new ModuleTableName('Stocks', 'BufferChangeReasons');
        this.translateService.get('BufferChangeReasons').subscribe(t => this.mainRowsSheetName = t);
    }

    @Input()
    public isActive: boolean;

    @Input()
    private reasons: BufferChangeReason[];

    @Input()
    private showDate: boolean;

    @Input()
    public canSend: boolean;

    private translates: { [key: string]: string };

    private translatesLoaded: boolean;

    protected readonly headersDataView: Slick.Data.DataView<any>;

    // protected headersColumns: ISlickGridColumn<any>[];

    protected readonly headersOptions: Slick.GridOptions<any>;

    protected sku: string;

    protected warehouseCode: string;

    // private scrollHandled: boolean;
    //
    // private mainViewport: HTMLElement;
    //
    // private headersViewport: HTMLElement;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['reasons'] || changes['showDate'])
            this.setData();

        if (!changes['isActive'].currentValue)
            return;

        this.helper.wait(() => this.onTabsResized(this.sharedGUID), 1);
    }

    //# freeze first column in grid
    private setFreeze = (): void => {
        if (this.gridRef){
            this.gridRef.setFreezeColumns(1);
            this.helper.wait(() => this.onTabsResized(this.sharedGUID), 5)
        }
    }

    //# close current tab
    public removeTab = (tab: ITabInfo): void =>{

        this.close.emit(tab);

    }

    //# use default function for export data
    protected getExportData = this.getExportDataByDefault;

    //# convert data to needed format
    private setData = (): void => {
        this.translateService.get(this.columnSettings.map(item => item.translateKey)).subscribe(t => {
            this.translates = t;
            this.translatesLoaded = true;
        });
        let done = false;
        IntervalObservable.create(10).takeWhile(() => !this.destroyed && !done).subscribe(() => {
            if (!this.translatesLoaded)
                return;

            done = true;

            const rows = [];

            this.columnSettings.forEach((item, i) => {
                if (i === 0 ){
                    if (this.showDate){
                        rows.push({ id: (i + 1).toString(), h: this.translates[item.translateKey] });
                    }
                } else{
                    rows.push({ id: (i + 1).toString(), h: this.translates[item.translateKey] });
                }
            });

            let columns: any[] = [{ id: 'h', field: 'h', name: this.showDate ? 'Date' : 'Reason', sortable: false, focusable: false, selectable: false, cssClass: 'first' }];

            const fields = this.columnSettings.map(item => this.helper.lowerCaseFirstLetter(item.columnName));
            //const rows = [];

            fields.forEach((item, i) => {
                if (item === 'reason' && !this.showDate){
                    return;
                }
                for (const reason of this.reasons){
                    rows[i][reason.date.format('L')] = reason[item];
                }
            })

            for (let i = 0; i < this.reasons.length; i++)
                columns.push({
                    id: `col${i}`,
                    field: this.reasons[i].date.format('L'),
                    name: this.showDate ? this.reasons[i].date.format('L') : this.reasons[i].reason,
                    sortable: false,
                    tooltip: 'auto'
                });

            this.columns = columns;

            this.dataView.setItems(rows);
            // this.gridRef.resizeGrid();
            this.helper.wait(() => this.setFreeze(), 5);

        });
    }

    //# download excel
    public onDownloadClick = (): void => {
        const fileName = `${this.mainRowsSheetName}_SKU_${this.tab.itemInfo.sku}_Wrh_${this.tab.itemInfo.warehouseCode}.xlsx`;
        this.download(data => this.excelService.downloadReport(
            data.columns,
            data.mainRows,
            [],
            [],
            this.translateService.currentLang,
            this.mainRowsSheetName,
            'descCode',
            [this.gridPropsName],
            0,
            this.mainRowsSheetName,
            []
        )
            .map(file => { return { fileContent: file, fileName }; }));
    }

    //# send excel to email
    public onSendClick = (): void => {
        this.sendToEmail(data => this.excelService.sendReport(
            this.tab.itemInfo.sku,
            this.tab.itemInfo.warehouseCode,
            data.columns,
            data.mainRows,
            [],
            [],
            this.translateService.currentLang,
            this.mainRowsSheetName,
            'descCode',
            [this.gridPropsName],
            0,
            this.mainRowsSheetName,
            [],
            this.mainRowsSheetName
        ));
    }

    // private onHeaderColumnsResized = (/*args: EventArgs<Slick.OnColumnsResizedEventArgs<any>>*/): void => {
    //     this.onTabsResized();
    // }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/buffer-change-reasons.component/buffer-change-reasons.component.ts